import Axios from "./Axios";

export default class ProductService extends Axios {
  getProducts(filter = {}, categoryId) {
    let request = `/rql/products`;
    if (categoryId != null) request += `/category/${categoryId}`;

    return this.axios.post(request, { filter });
  }

  getProductsCombos(filter = {}, categoryId) {
    let request = `/rql/products-combos`;
    if (categoryId != null) request += `/category/${categoryId}`;

    return this.axios.post(request, { filter });
  }

  async getByID(id) {
    const res = await this.getProducts({ id: parseInt(id) });

    return res.data.products[0];
  }

  async getProductComboByID(id) {
    const res = await this.getProductsCombos({ id: parseInt(id) });

    return res.data.products[0];
  }
}
